// Angular
import {
	Component,
	EventEmitter,
	Input,
	OnDestroy,
	OnInit,
	Output,
	ViewEncapsulation
} from '@angular/core';
// State
import { Store } from '@ngxs/store';
import { SetReleaseNotes } from '../../action/state.action';
// Service
import { ConfigService } from '../../service/config.service';
// Other
import { Observable, Subject } from 'rxjs';
import { AppInformationService } from '../../service/app-info.service';

@Component({
	selector: 'cv-header',
	templateUrl: './header.component.html',
	encapsulation: ViewEncapsulation.None,
	styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit, OnDestroy {
	@Input() isPWAMobile = false;
	@Input() profile: Observable<any>;
	@Output() DisplayNav: EventEmitter<any> = new EventEmitter<any>();

	private atComponentDestroy = new Subject();
	public toggleUser: boolean;
	public releasesNotes: any = {
		open: false,
		notes: []
	};

	constructor(
		private configService: ConfigService,
		private store: Store,
		private appInfo: AppInformationService
	) {

	}

	ngOnInit(): void {
		// Get All Release Notes so far only for Browser Version
		if (!this.isPWAMobile) {
			// this.configService.getReleaseNotes().subscribe((releaseNotesOf: any) => {
			// 	this.releasesNotes.notes = releaseNotesOf;
			// });
		}
	}

	/**
	 * Open release notes
	 * @param event
	 */
	public openLastUpdates(): void {
		const systemNotes = this.releasesNotes.notes.find((release: any) =>
			this.appInfo.currentUrl.includes(release.system)
		);

		if (systemNotes) {
			this.store.dispatch(new SetReleaseNotes(systemNotes.release[0], this.appInfo.appName)).subscribe(() => {
				this.releasesNotes.open = true;
			});
		}

		this.toggleUser = true;
	}

	/**
	 * Close all when the element is destroyed
	 */
	ngOnDestroy(): void {
		// Globally Destroy anything attached to it
		this.atComponentDestroy.next({});
		this.atComponentDestroy.unsubscribe();
	}
}
